import { SimplifiedBasketItem } from "../utils/types";
import { TickOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickOutlined";
import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

import styles from "./ProductBasketItems.module.scss";

type BasketConfirmationProps = {
  basket: SimplifiedBasketItem[];
};

export const ProductBasketItems = ({ basket }: BasketConfirmationProps) => {
  return (
    <>
      <div aria-live="polite">
        <h2>Added to your basket:</h2>
        <ul className={styles.list}>
          {basket.map(({ id, title, quantity }) => (
            <li key={id} className={styles.listItem}>
              <TickOutlined />
              <div className={styles.text}>
                {quantity} x {title}
              </div>
            </li>
          ))}
        </ul>
      </div>

      <PrimaryButton tag="a" target="_top" href="/basket">
        Go to your basket
      </PrimaryButton>
    </>
  );
};
